__turbopack_context__.v({
  "allNewsBtn": "ERLs6G_allNewsBtn",
  "contentStyles": "ERLs6G_contentStyles",
  "newsBottomController": "ERLs6G_newsBottomController",
  "rowsContainer": "ERLs6G_rowsContainer",
  "showAllNewsBtn": "ERLs6G_showAllNewsBtn",
  "sliderControllerBtn": "ERLs6G_sliderControllerBtn",
  "sliderControllerBtnDiactive": "ERLs6G_sliderControllerBtnDiactive",
  "titleH3Styles": "ERLs6G_titleH3Styles",
});
